import { Stack } from "@mui/material";
import { useContext } from "react";
import ConnectDynamicForm from "src/pages/Link/DynamicForm/ConnectDynamicForm.tsx";
import { CustomConnectProps } from "src/pages/Link/DynamicForm/context.ts";
import LogoViewer from "src/pages/Link/Products/Common/ConnectStep/LogoViewer.tsx";
import { entitiesUrl } from "src/utils/formatUrl.ts";

import Context from "../../context.ts";
import BackBtn from "../components/BackBtn.tsx";

// ----------------------------------------------------------------------

export const ConnectStep = () => {
	const { state, actions, type } = useContext(Context);

	const onConnect = (token: string) => {
		actions.onConnectAccount(token);
	};

	const formProps: CustomConnectProps = {
		onConnect,
		themeType: "",
		updateToken: "",
		restoreToken: "",
		showSaveCheckbox: false
	};

	return (
		<Stack minWidth={{ xs: 250, sm: 330 }}>
			<BackBtn onClick={() => actions.setStep(2)} />
			<LogoViewer src={entitiesUrl(state.entity?.id ?? "")} />
			<ConnectDynamicForm
				id={state.token}
				product={type}
				entity={state.entity}
				customConnectProps={formProps}
			/>
		</Stack>
	);
};

export default ConnectStep;
